export default __webpack_public_path__ + "static/media/img-6.704d2951.jpg";